import React from 'react'
import ReactDOM from 'react-dom'
import {useFormikContext} from "formik"
import {useTranslation} from "react-i18next"
import {useHistory} from 'react-router-dom'
import store from "@formApp/store"

const PayPalButton = paypal.Buttons.driver("react", { React, ReactDOM });

export default ({payment}) => {
  const {t} = useTranslation();
  let history = useHistory();
  const formContext = useFormikContext();
  const {formValues, domainsList} = React.useContext(store);
  let [error, setError] = React.useState(null);

  const createSubscription = async () => {
    let savedValues = formValues.getAllValues();
    const {paypalParams} = savedValues;
    // format values for endpoint
    savedValues = {...savedValues, ...paypalParams}; // country, pp_item_id, pp_item_value
    savedValues.account = savedValues.dataId;
    savedValues.subscription = payment;
    const res = await fetch(paypalParams.pp_api_endpoint, {
      method: 'POST',
      headers: new Headers({
        'Authorization': 'AvToken ' + paypalParams.pp_api_token,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify(savedValues)
    });
    if (res.ok !== true) throw new Error(res.statusText);
    const dataRes = await res.json();
    return dataRes.subscription_id;
  };
  const onClick = async (data, actions) => {
    setError(null);
    await formContext.submitForm();
    return (formContext.isValid)
      ? actions.resolve()
      : actions.reject();
  };
  const onApprove = async () => {
    let savedValues = formValues.getAllValues();
    try {
      const {paypalParams} = savedValues;
      const formEncoded = new URLSearchParams();
      formEncoded.append('id', savedValues.dataId);
      formEncoded.append('pp_id', paypalParams.pp_id);
      formEncoded.append('siteName', savedValues.siteName);
      formEncoded.append('domain', savedValues.domain);
      const res = await fetch('https://aa.altervista.org/cgi-bin/joinus-checkout.pl', {
        method: 'POST',
        body: formEncoded
      });
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();
      if (data.status === 'ok') {
        clearForm();
        history.push('step-confirm-host');

        const priceInfo = paypalParams.pp_item_price[payment];
        // TODO make endpoint return raw number, not formatted strings
        const priceWithTax = Number(priceInfo.price_with_tax.replace(",", "."));
        const priceWithoutTax = Number(priceInfo.price.replace(",", "."));
        dataLayer.push({
          event: 'transaction_sent',
          transactionId: `subscription#${data.subscription_id}`,
          transactionTotal: priceWithTax,
          transactionTax: priceWithTax - priceWithoutTax,
        });
      } else if (data.status === 'error' && data.error_code === 'checkout') {
        throw new Error("Si è verificato un errore nella conferma del tuo pagamento. Se il problema persiste contattaci.");
      } else {
        throw new Error(data);
      }
    } catch (err) {
      clearForm();
      setError(err)
    }
  };
  const clearForm = () => {
    domainsList.clearSelected();
    domainsList.clear();
    domainsList.clear2();
  };
  const onError = (err) => {
    const savedValues = formValues.getAllValues();
    const formEncoded = new URLSearchParams();
    formEncoded.append('err_src', savedValues.paypalParams.pp_id);
    formEncoded.append('err', ((typeof err != 'string') ? JSON.stringify(err) : err));
    const res = fetch('https://aa.altervista.org/cgi-bin/joinus-checkout.pl', {
      method: 'POST',
      body: formEncoded
    });
    setError(err);
  };
  return (
    <>
      <PayPalButton
        onClick={onClick}
        createSubscription={createSubscription}
        onApprove={onApprove}
        onError={onError}
      />
      <div className='totalRefund-disclaimer'>
        <img src='/images/icon-pocket.svg' />
        {t('Se poi non ti piace ti rimborsiamo al 100%')}
      </div>
      <div className='formSection formErrors'>
        <div className="error formGroup">
          {error &&
            <div className='errorMessage'>
              {(error.message)
                ? t(error.message) // i18next-extract-disable-line
                : t("Si è verificato un errore nella conferma del tuo pagamento. Se il problema persiste contattaci.")
              }
            </div>
          }
        </div>
      </div>
    </>
  )
}